import { t } from '@if/core/i18n'
import { ESourceSystem } from '@if/core/types'
import * as yup from '@if/core/yup'
import { EMerchantReportFrequency } from './Constants'

const bannerNameRegex = /^[-a-zA-Z0-9&.,'\u2018\u2019 ]+$/
const bannerSchema = {
  name: yup
    .string()
    .matches(bannerNameRegex, () => t('common.errors.bannerNameInvalid'))
    .max(100, () => t('common.errors.tooManyCharacters'))
    .required(),
  serviceCategory: yup.string().required(),
  email: yup
    .string()
    .email()
    .max(256, () => t('common.errors.tooManyCharacters')),
  phone: yup.string().validCanadianPhone().notRequired(),
  website: yup
    .string()
    .url()
    .notRequired()
    .max(256, () => t('common.errors.tooManyCharacters')),
  address: yup
    .string()
    .notRequired()
    .max(100, () => t('common.errors.tooManyCharacters')),
  city: yup
    .string()
    .notRequired()
    .max(50, () => t('common.errors.tooManyCharacters')),
  province: yup.string().notRequired(),
  zipCode: yup.string().notRequired(),
  languageId: yup.number().required(),
  sourceSystem: yup.string().default(ESourceSystem.Alis).notRequired(),
  id: yup.string().notRequired(),
  reportGenerationFrequency: yup
    .string()
    .nullable()
    .oneOf(['', ...Object.values(EMerchantReportFrequency)])
    .default(EMerchantReportFrequency.never),
  reportRecipientsEmailList: yup.array().of(yup.string().email().required()).default([]),
  noPaymentPolicy: yup.boolean().required().default(false),
  hideAddress: yup.boolean().required().default(false),
  canSkipFlinks: yup.boolean().required().default(false),
  canPayBorrowers: yup.boolean().required().default(false),
  automaticIncomeApproval: yup.boolean().required().default(false),
  canAcceptHighEstimate: yup.boolean().required().default(false),
  showInterestRateOnMerchantDashboard: yup.boolean().required().default(false),
  worksheetByMerchant: yup.boolean().required().default(false),
  ownedFields: yup.array().of(yup.string().required()).default([]),
  // true = banner defines one buydown for all its merchants; false = each merchant manages its own.
  flashPlanDefinedInManageMerchant: yup.boolean().required().default(false),
  // Required (min 1) only when the banner defines the buydown, which needs a recipient on file.
  promoNotificationEmailList: yup
    .array()
    .of(yup.string().email().required())
    .required()
    .when('flashPlanDefinedInManageMerchant', {
      is: true,
      then: (schema) => schema.min(1),
    })
    .default([]),
  flashPlanRateRebate: yup.percent().min(0).max(0.03).required().default(0),
}
export const BannerSchema = yup.object().shape(bannerSchema)

export type BannerDto = yup.InferSubmit<typeof BannerSchema>
